import React, { PropsWithChildren, useEffect, useState } from "react";

type Props = PropsWithChildren<{
  timeoutMs?: number;
}>;

const DeferredUntilIdle: React.FC<Props> = ({ children, timeoutMs = 3000 }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let idleCallbackId: number | undefined;
    let isCancelled = false;

    const render = () => {
      if (!isCancelled) setShouldRender(true);
    };

    const renderDuringIdle = () => {
      if ("requestIdleCallback" in window) {
        idleCallbackId = window.requestIdleCallback(render, {
          timeout: timeoutMs
        });
      } else {
        setTimeout(render, 0);
      }
    };

    if (document.readyState === "complete") {
      renderDuringIdle();
    } else {
      window.addEventListener("load", renderDuringIdle, { once: true });
    }

    return () => {
      isCancelled = true;
      window.removeEventListener("load", renderDuringIdle);
      if (idleCallbackId !== undefined && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleCallbackId);
      }
    };
  }, [timeoutMs]);

  if (!shouldRender) return null;

  return <>{children}</>;
};

export default DeferredUntilIdle;
